<template>

    <div v-if="!fetcher.loading">

        <div v-if="disabled">

        </div>

        <div class="alert alert-warning mb-6" role="alert" v-if="disabled">
            Du behöver först göra inställningar för abonnemanget. Därefter kan du redigera priserna.
        </div>

        <div class="new-list-group" v-if="!disabled">

            <div class="new-list-group-item new-list-group-header no-decoration">

                <div class="row">
                    <div class="col-4"><span>Pris gäller från</span></div>
                    <div class="col-6" v-if="subscription.type !== 'pay_per_treatment'"><span>Månadskostnad</span></div>
                    <div class="col-6" v-if="subscription.type !== 'pay_per_treatment' && subscription.type !== 'unlimited'"><span>Pris per extra behandling</span></div>
                    <div class="col-6" v-if="subscription.type === 'pay_per_treatment'"><span v-if="subscription.internal === 1">Pris per beh. på mottagning</span></div>
                    <div class="col-6" v-if="subscription.type === 'pay_per_treatment'"><span v-if="subscription.external === 1">Pris per beh. på arbetsplatsen</span></div>
                    <div class="col-4" v-if="subscription.external === 1"><span>Månadsavg. bokningssystem</span></div>
                    <div class="col-4" v-else></div>
                    <div class="col-4"></div>
                </div>

            </div>

            <prices-row
                v-for="period in pricePeriods"
                :key="period.id"
                :untouched-period="period"
                :subscription="subscription"
                @refresh="fetcherFetch()"
            />

            <prices-row-new
                :key="'new_'+pricePeriods.length"
                :subscription="subscription"
                @refresh="fetcherFetch()"
            />

        </div>

    </div>

</template>

<script>
import pricesRow from './prices-row'
import pricesRowNew from './prices-row-new'

import fetcher from '../../../../shared/mixins/fetcher'

export default {

    mixins: [
        fetcher
    ],

    components: {
        pricesRow,
        pricesRowNew
    },

    props: {
        subscription_id: {
            required: true
        }
    },

    data () {
        return {
            subscription: null,
            pricePeriods: [],
            fetcher: {
                autoFill: [
                    'subscription',
                    'pricePeriods'
                ]
            }
        }
    },

    computed: {
        fetcherUrl () {
            return '/subscriptions/' + this.subscription_id + '/tabSettings'
        },
        disabled () {
            if (!this.subscription.name || !this.subscription.name_public) {
                return true
            }
            if (!this.subscription.duration_id) {
                return true
            }
            if (!this.subscription.internal && !this.subscription.external) {
                return true
            }
            return false
        }
    },

    methods: {

    }
}
</script>
